import React from 'react';

export const VaultComponent: React.FC = () => {
    const vaultPath: any = { vaultPath: 'metakitchen' };

    return <div id="diamond-vaults" {...vaultPath}></div>;
}